import { Checkbox } from "@babackapp/customer-ui/components/checkbox";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useSetNotifyCustomer } from "@babackapp/return-widget-components/hooks/use-set-notify-customer";
import { useSetWithShippingLabel } from "@babackapp/return-widget-components/hooks/use-set-with-shipping-label";
import { useTranslation } from "react-i18next";
import { useIsMerchant } from "../hooks/use-is-merchant";

/**
 * Merchant-only overrides shown on the confirmation screen: skip the customer
 * notification and/or the shipping-label generation. Mirrors the operator
 * checkboxes from the legacy widget (ConfirmReturn.tsx). Hidden for customers.
 */
export function MerchantReturnOptions({ orderId }: { orderId: string }) {
  const isMerchant = useIsMerchant();
  const { t } = useTranslation("return-widget-v3");
  const draft = useDraftReturn(orderId);
  const setNotifyCustomer = useSetNotifyCustomer(orderId);
  const setWithShippingLabel = useSetWithShippingLabel(orderId);

  if (!isMerchant || !draft) return null;

  const showLabelOption =
    draft.returnMode !== "store" && draft.returnMode !== "retractation";

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-admin-border bg-admin/5 p-4">
      <label className="flex items-center gap-2 text-sm text-muted-foreground">
        <Checkbox
          checked={draft.notifyCustomer ?? true}
          onCheckedChange={(checked) => setNotifyCustomer(checked === true)}
        />
        {t("merchantOptions.notifyCustomer")}
      </label>
      {showLabelOption && (
        <label className="flex items-center gap-2 text-sm text-muted-foreground">
          <Checkbox
            checked={draft.withShippingLabel ?? true}
            onCheckedChange={(checked) => setWithShippingLabel(checked === true)}
          />
          {t("merchantOptions.generateLabel")}
        </label>
      )}
    </div>
  );
}
